// Validación de contraseñas nuevas (§3): mínimo 12 caracteres y repetición coincidente.
// bcrypt (Auth) solo considera 72 bytes; más se rechaza en lugar de truncar en silencio.

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_BYTES = 72;

export interface PasswordErrors {
  password?: string;
  repeat?: string;
}

export function validateNewPassword(password: string, repeat: string): PasswordErrors {
  const errors: PasswordErrors = {};
  if ([...password].length < PASSWORD_MIN_LENGTH) {
    errors.password = `La contraseña debe tener al menos ${PASSWORD_MIN_LENGTH} caracteres.`;
  } else if (new TextEncoder().encode(password).length > PASSWORD_MAX_BYTES) {
    errors.password = 'La contraseña es demasiado larga.';
  }
  if (repeat === '') {
    errors.repeat = 'Repite la contraseña.';
  } else if (repeat !== password) {
    errors.repeat = 'Las contraseñas no coinciden.';
  }
  return errors;
}

export function hasErrors(errors: object): boolean {
  return Object.values(errors).some(Boolean);
}
